import { api } from "../helpers";
import { useHttp } from "../http-hook/http.hook";

const useContentService = () => {
  const { request } = useHttp();

  const getAllBlogs = async (page = 1, limit = 5, setPagination) => {
    try {
      const res = await request(
        `${api}/blogs?page=${page}&limit=${limit}`,
        "GET"
      );
      setPagination((prev) => ({
        ...prev,
        blogs: res.blogs,
        totalPages: res.pagination.totalPages,
        currentPage: res.pagination.currentPage,
      }));
    } catch (e) {
      throw new Error(e.message || "Failed to fetch blogs");
    }
  };
  const getNewestBlog = async (setBlog) => {
    try {
      const res = await request(`${api}/blogs/newest/:id`, "GET");
      setBlog(res);
    } catch (e) {
      const msg = e?.message || "";
      if (msg === "No blogs found" || /no blogs found/i.test(msg)) {
        setBlog(null);
        return;
      }
      throw new Error(msg || "Failed to fetch newest blog");
    }
  };
  const getBlogById = async (id) => {
    try {
      const res = await request(`${api}/blogs/${id}`, "GET");
      return res;
    } catch (e) {
      throw new Error(e.message || "Failed to fetch blog");
    }
  };

  const getContentByType = async (type, setContent) => {
    try {
      const res = await request(`${api}/content?type=${type}`, "GET");
      setContent(res);
    } catch (e) {}
  };

  const getPolicySections = async (pageType, setContent, setLoading) => {
    try {
      const res = await request(`${api}/policies?pageType=${pageType}`, "GET");
      setContent(res);
      setLoading(false);
    } catch (e) {}
  };

  const searchLoads = async (vin) => {
    try {
      const res = await request(`${api}/loads?vin=${vin}`, "GET");
      return res;
    } catch (e) {
      throw new Error(e.message || "Failed to search loads");
    }
  };

  const getContacts = async (setContact) => {
    try {
      const res = await request(
        `${api}/content/contacts`,
        "GET"
      );
      setContact(res);
    } catch (e) {}
  };

  return {
    getAllBlogs,
    getNewestBlog,
    getContacts,
    getPolicySections,
    getContentByType,
    getBlogById,
    searchLoads,
  };
};

export default useContentService;
